module.exports = __webpack_public_path__ + "img/word-empty.4589afae.png";